import React from "react";
import PropTypes from "prop-types";
import { Title } from "./Title";
import { Wrapper } from "./Wrapper";
import "./style.scss";

/**
 * GroupC:
 *  - Group is reponsible for displaying the following NODE_TYPE: [STEP_NODE]
 *  - Used in DesignViewThree
 */
export function GroupC(props) {
  const onDropStep = React.useCallback((params) => {
    props.onDropStep({ ...params, groupId: props.groupId });
  }, []);

  const onRemoveStep = React.useCallback((params) => {
    props.onRemoveStep({ ...params, groupId: props.groupId });
  }, []);

  const stepNode = (n) => {
    return React.cloneElement(props.stepNode, {
      ...props.stepNode.props,
      key: n.nodeId,
      nodeId: n.nodeId,
      onDropStep: onDropStep,
      onRemoveStep: onRemoveStep,
      nodeComponents: n.nodeComponents,
    });
  };

  const className = `design-view__groupC ${props.className}`;

  return (
    <Wrapper className={className} color={props.groupColor}>
      <Title title={props.groupTitle} className="design-view__groupC--title" />
      {props.groupNodes.map(stepNode)}
    </Wrapper>
  );
}

GroupC.propTypes = {
  /**
   * groupId
   */
  groupId: PropTypes.number,
  /**
   * List of nodes to display in Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Node
       */
      nodeId: PropTypes.number,
      /**
       * Type of Node
       */
      nodeType: PropTypes.oneOf(["STEP_NODE"]),
      /**
       * List of components to display on Node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  /**
   * Title for the Group
   */
  groupTitle: PropTypes.string,
  /**
   * Theme color for the group
   */
  groupColor: PropTypes.string,
  /**
   * Function for when Step is dropped in Node
   */
  onDropStep: PropTypes.func,
  /**
   * Function for when a Step is removed from Node
   */
  onRemoveStep: PropTypes.func,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

GroupC.defaultProps = {
  className: "",
  groupNodes: [],
};
